module.exports = __webpack_public_path__ + "img/step06_a_stand_basic_left_bottom_cross_Juliol2023.7172fe95.png";